export default __webpack_public_path__ + "static/media/Hedda_neutral.c6e72c0e.jpg";